import {connect, MapStateToProps} from 'react-redux'
import React from 'react'
import visualizationSelector from '../../../redux/selectors/visualizationSelector'
import consumptionDataSelector from '../../../redux/selectors/consumptionDataSelector'
import e3dRenderImagesSelector, { IE3DRenderImage } from '../../../redux/selectors/e3dRenderImagesSelector'
import activeRenderImgIdxSelector from '../../../redux/selectors/activeRenderImgIdxSelector'
import E3DStream from './E3DStream'
import Visualization from '../../../entities/Visualization'
import { isE3DAvailable } from '../../../hooks/useE3DAvailability'
import is3DExhibitionEnabledSelector from '../../../redux/selectors/feature-scope/is3DExhibitionEnabledSelector'
import configuredCarlineNameSelector from '../../../redux/selectors/carlines/configuredCarlineNameSelector'
import { useE3DReinit } from '../e3d-context/E3DReinitContext'
import e3dHideHangupButtonSelector from '../../../redux/selectors/e3dHideHangupButtonSelector'
import e3dForceWltpDataUpdateSelector from '../../../redux/selectors/e3dForceWltpDataUpdateSelector'

type StateProps = {
    visualization: Visualization
    consumptionData: string[]
    isE3DAvailable: boolean
    carlineName: string
    e3dRenderImages: IE3DRenderImage[]
    activeRenderImgIdx: number
    hideHangupButton: boolean
    forceWltpDataUpdate: boolean
}

type OwnProps = {
    setIsE3DStreamActive?: (active: boolean) => void
}

const mapStateToProps: MapStateToProps<StateProps, OwnProps> = (state): StateProps => {
    const is3DEnabled = is3DExhibitionEnabledSelector(state)
    return {
        visualization: visualizationSelector(state),
        consumptionData: consumptionDataSelector(state),
        isE3DAvailable: is3DEnabled && isE3DAvailable(),
        carlineName: configuredCarlineNameSelector(state),
        e3dRenderImages: e3dRenderImagesSelector(state),
        activeRenderImgIdx: activeRenderImgIdxSelector(state) || 0,
        hideHangupButton: e3dHideHangupButtonSelector(state),
        forceWltpDataUpdate: e3dForceWltpDataUpdateSelector(state),
    }
}

const E3DStreamContainer: React.FC<StateProps & OwnProps> = (props) => {
    const { reinitCounter } = useE3DReinit()

    return <E3DStream key={reinitCounter} {...props} />
}

export default connect(mapStateToProps)(E3DStreamContainer)
